/**
 * Regels rond accounts en uitnodigingen die client en worker delen, zodat het
 * invoerveld dezelfde uitkomst geeft als de server. De server blijft de plek
 * waar het wordt afgedwongen.
 */
/**
 * Het pad van de uitnodigingslink, op één plek.
 *
 * De worker bouwt hiermee de link in de mail, de client registreert hiermee
 * zijn route. Dat is geen nette-code-oefening: ze stonden los van elkaar en
 * liepen uiteen, de mail wees naar `/uitnodiging/<token>` en de route heette
 * `/account-aanmaken` zonder tokensegment. Klikken op de link kwam dus in het
 * vangnet en daarna op de inlogpagina. Typecheck en lint zien zo'n verschil
 * niet, want het zijn twee strings die niets van elkaar weten.
 *
 * `UITNODIGING_PAD` is het patroon voor de router, `uitnodigingsPad` maakt het
 * echte pad. Het token blijft een padsegment en wordt geen queryparameter:
 * `AccountAanmakenPage` leest hem met `useParams`, en een pad houdt hem uit de
 * `Referer`-header als de pagina ooit iets extern zou laden.
 */
export const UITNODIGING_PAD = '/uitnodiging/:token';
export const uitnodigingsPad = (token) => `/uitnodiging/${token}`;
/** Wachtwoord vergeten: twee schermen. `WACHTWOORD_VERGETEN_PAD` is het formulier
 *  waar je je adres invult (de link staat op het inlogscherm), `HERSTEL_PAD` is
 *  het scherm achter de link uit de mail. Zelfde reden als hierboven om ze hier
 *  te zetten: de worker bouwt de link, de client registreert de route. */
export const WACHTWOORD_VERGETEN_PAD = '/wachtwoord-vergeten';
export const HERSTEL_PAD = '/wachtwoord-herstellen/:token';
export const herstelPad = (token) => `/wachtwoord-herstellen/${token}`;
/** Trim plus kleine letters. Adressen zijn case-insensitive in de praktijk, en
 *  `User.email` is uniek: zonder normaliseren komt hetzelfde adres er twee keer
 *  in met een hoofdletterverschil. */
export function normaliseerEmail(email) {
    return email.trim().toLowerCase();
}
/** Bewust simpel: één @, iets ervoor, en een domein met een punt erin. Een
 *  strenger patroon dan dit levert vooral valse afwijzingen op. */
const BASIS_PATROON = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Geeft de reden terug waarom dit adres niet kan, of null als het mag. */
export function keurAccountEmail(email) {
    const genormaliseerd = normaliseerEmail(email);
    if (!genormaliseerd)
        return 'Vul een e-mailadres in.';
    if (!BASIS_PATROON.test(genormaliseerd))
        return 'Dit is geen geldig e-mailadres.';
    return null;
}
